import { create } from "zustand";

const playerResourceTotalStore = create((set, get) => ({
  playerResourceTotals: {}, // Lưu trữ tất cả các player và config của họ

  // Cập nhật một config trong một player cụ thể
  updateSingleResourceTotal: (playerId, resourceId, value) => {
    if (value === get().playerResourceTotals[playerId][resourceId]) {
      return;
    }
    set((state) => (
      {
        playerResourceTotals: {
          ...state.playerResourceTotals,
          [playerId]: {
            ...state.playerResourceTotals[playerId], // Giữ lại các config cũ
            [resourceId]: value, // Cập nhật config cụ thể
          },
        },
      }))
  },

  // Cập nhật toàn bộ config của một player
  updatePlayerResourceTotal: (playerId, newResource) =>
    set((state) => ({
      playerResourceTotals: {
        ...state.playerResourceTotals,
        [playerId]: newResource, // Cập nhật toàn bộ config của player
      },
    })),

  // Cập nhật nhiều player cùng lúc
  updateMultiplePlayersResourceTotal: (newResources) =>
    set((state) => ({
      playerResourceTotals: {
        ...state.playerResourceTotals,
        ...newResources, // Merge với configs hiện tại
      },
    })),
}));

export default playerResourceTotalStore;
